import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import Select from "react-select";
import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import { actualizarUsuarioMovil, crearUsuarioMovil, countUsuarioMovil } from "../../../api/api-usuario-movil";
import { obtenerListaPais } from "../../../api/api-pais";
import { obtenerListaCiudad, obtenerListaCiudadPorPais } from "../../../api/api-ciudad";
import { obtenerTodasLasUnidades } from "../../../api/gestion-dts/gestion";
import { obtenerListaTipoUsuarioMovil } from "../../../api/api-tipo-usuario-movil";
import BtnRequestComponent from "../../../components/btn-request";
import { useToast, useProcessing } from "../../../context/ui-feedback-context";
import { obtenerListaTipoChofer } from "../../../api/api-tipo-chofer";
import { obtenerListaEjesVehiculo } from "../../../api/api-ejes-vehiculo";
import { obtenerListaEstadoVehiculo } from "../../../api/api-estado-vehiculo";

export default function UsuarioMovilPage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");

  const [listaPais, setListaPais] = useState([]);
  const [paisSelected, setPaisSelected] = useState(null);

  const [listaCiudad, setListaCiudad] = useState([]);
  const [ciudadSelected, setCiudadSelected] = useState(null);

  const [listaUnidad, setListaUnidad] = useState([]);
  const [unidadSelected, setUnidadSelected] = useState(null);

  const [listaTipoUsuarioMovil, setListaTipoUsuarioMovil] = useState([]);
  const [tipoUsuarioMovilSelected, setTipoUsuarioMovilSelected] = useState(null);

  const { showProcessing, hideProcessing } = useProcessing();
  const { showToast } = useToast();
  const [sendRequest, setSendRequest] = useState(false);

  const [listaTipoChofer, setListaTipoChofer] = useState([]);
  const [tipoChoferSelected, setTipoChoferSelected] = useState(null);

  const [listaEjesVehiculo, setListaEjesVehiculo] = useState([]);
  const [ejesVehiculoSelected, setEjesVehiculoSelected] = useState(null);

  const [listaEstadoVehiculo, setListaEstadoVehiculo] = useState([]);
  const [estadoVehiculoSelected, setEstadoVehiculoSelected] = useState(null);

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  useEffect(() => {
    if (paisSelected !== null) {
      setCiudadSelected(null);
      buscarCiudadesPorPais();
    }
    if (paisSelected === null) {
      setListaCiudad([]);
      setCiudadSelected(null);
    }
  }, [paisSelected]);

  useEffect(() => {
    // console.log("tipoUsuarioMovilSelected");
    // console.log(tipoUsuarioMovilSelected);
  }, [tipoUsuarioMovilSelected]);

  const buscarCiudadesPorPais = async () => {
    showProcessing();
    const ciudad = await obtenerListaCiudadPorPais({ idPais: paisSelected.value }, true, t);
    setListaCiudad(ciudad);
    hideProcessing();
  }

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }

      const [paises, ciudades, unidades, tipoUsuarioMovil, tipoChofer, ejesVehiculo, estadoVehiculo] = await Promise.all([
        obtenerListaPais({ habilitado: 1 }, true),
        obtenerListaCiudad({ habilitado: 1 }, true),
        obtenerTodasLasUnidades(),
        obtenerListaTipoUsuarioMovil({ habilitado: 1 }, true, t),
        obtenerListaTipoChofer({ habilitado: 1 }, true, t),
        obtenerListaEjesVehiculo({ habilitado: 1 }, true, t),
        obtenerListaEstadoVehiculo({ habilitado: 1 }, true, t),
      ]);

      // const paises = await obtenerListaPais({ habilitado: 1 }, true);
      setListaPais(paises);
      if (data.params.idPais !== undefined && data.params.idPais !== null) {
        const pais = paises.find((item) => item.value === data.params.idPais);
        setPaisSelected(pais);
      }
      // const ciudades = await obtenerListaCiudad({ habilitado: 1 }, true);
      setListaCiudad(ciudades);
      if (data.params.idCiudad !== undefined && data.params.idCiudad !== null) {
        const ciudad = ciudades.find((item) => item.value === data.params.idCiudad);
        setCiudadSelected(ciudad);
      }

      // const unidades = await obtenerTodasLasUnidades();
      setListaUnidad(unidades);
      if (data.params.valuePlaca !== undefined && data.params.valuePlaca !== null) {
        const unidad = unidades.find((item) => item.value === data.params.valuePlaca);
        setUnidadSelected(unidad);
      }

      // const tipoUsuarioMovil = await obtenerListaTipoUsuarioMovil({ habilitado: 1 }, true, t);
      // console.log("tipoUsuarioMovil");
      // console.log(tipoUsuarioMovil);
      setListaTipoUsuarioMovil(tipoUsuarioMovil);
      if (data.params.idTipoUsuarioMovil !== undefined && data.params.idTipoUsuarioMovil !== null) {
        const tipoUsuario = tipoUsuarioMovil.find((item) => item.value === data.params.idTipoUsuarioMovil);
        setTipoUsuarioMovilSelected(tipoUsuario);
      }


      // const tipoChofer = await obtenerListaTipoChofer({ habilitado: 1 }, true, t);
      // console.log("tipoChofer");
      // console.log(tipoChofer);
      setListaTipoChofer(tipoChofer);
      if (data.params.idTipoChofer !== undefined && data.params.idTipoChofer !== null) {
        const tipoSelected = tipoChofer.find((item) => item.value === data.params.idTipoChofer);
        setTipoChoferSelected(tipoSelected);
      }

      // const ejesVehiculo = await obtenerListaEjesVehiculo({ habilitado: 1 }, true, t);
      setListaEjesVehiculo(ejesVehiculo);
      if (data.params.idEjesVehiculo !== undefined && data.params.idEjesVehiculo !== null) {
        const ejesSelected = ejesVehiculo.find((item) => item.value === data.params.idEjesVehiculo);
        setEjesVehiculoSelected(ejesSelected);
      }

      // const estadoVehiculo = await obtenerListaEstadoVehiculo({ habilitado: 1 }, true, t);
      setListaEstadoVehiculo(estadoVehiculo);
      if (data.params.idEstadoVehiculo !== undefined && data.params.idEstadoVehiculo !== null) {
        const estadoSelected = estadoVehiculo.find((item) => item.value === data.params.idEstadoVehiculo);
        setEstadoVehiculoSelected(estadoSelected);
      }

    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
    }
  }

  const charLimits = {
    peso: 6,
    volumen: 6,
    usuario: 10,
    password: 10,
    nombreConductor: 64,
    nota: 256,
    licencia: 16,
    telefono: 16,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Allow only numbers and decimal point for peso and volumen
    if (name === 'peso' || name === 'volumen') {
      // Regex to match: digits and optionally one decimal point with digits after
      // Allows: empty string, digits only, digits with one decimal point
      const numericRegex = /^(\d+\.?\d*|\.\d*)?$/;
      if (value === '' || numericRegex.test(value)) {
        if (value.length <= charLimits[name]) {
          setFormData({
            ...formData,
            [name]: value,
          });
        }
      }
    } else {
      // Regular handling for other fields
      if (value.length <= charLimits[name]) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (tipoUsuarioMovilSelected === null || tipoUsuarioMovilSelected === undefined) {
        message = message + t("alert_debe_seleccionar_tipo_usuario_movil") + '\n';
      }
      // console.log("tipoUsuarioMovilSelected");
      // console.log(tipoUsuarioMovilSelected);
      // console.log("unidadSelected");
      // console.log(unidadSelected);
      if (tipoUsuarioMovilSelected?.puedeHacerGestionEstregeRecogoProductos === 1 && (unidadSelected === null || unidadSelected === undefined)) {
        message = message + t("alert_debe_seleccionar_vehiculo") + '\n';
      }
      if (tipoUsuarioMovilSelected?.puedeHacerGestionEstregeRecogoProductos === 1 && String(formData.peso).trim().length === 0) {
        message = message + t("alert_debe_ingresar_peso") + '\n';
      }
      if (tipoUsuarioMovilSelected?.puedeHacerGestionEstregeRecogoProductos === 1 && String(formData.volumen).trim().length === 0) {
        message = message + t("alert_debe_ingresar_volumen") + '\n';
      }
      if (String(formData.nombreConductor).trim().length === 0) {
        message = message + t("alert_debe_ingresar_nombre") + '\n';
      }
      if (String(formData.usuario).trim().length === 0) {
        message = message + t("alert_debe_ingresar_usuario") + '\n';
      }
      if (String(formData.password).trim().length === 0) {
        message = message + t("alert_debe_ingresar_password") + '\n';
      }
      if (message.length > 0) {
        alert(message);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const handleSaveClick = async () => {
    try {
      // console.log('handleSaveClick');
      // lógica para guardar los cambios
      // console.log('formData');
      // console.log(formData);
      const valido = validarFormulario();
      if (valido === false) {
        return;
      }
      let objEnviar = {};
      objEnviar.id = formData.id;
      objEnviar.idTipoUsuarioMovil = tipoUsuarioMovilSelected.value;
      objEnviar.idPais = paisSelected !== null ? paisSelected.value : null;
      objEnviar.idCiudad = ciudadSelected !== null ? ciudadSelected.value : null;

      objEnviar.valuePlaca = unidadSelected !== null ? unidadSelected.value : null;
      objEnviar.labelPlaca = unidadSelected !== null ? unidadSelected.label : null;
      objEnviar.nombreConductor = formData?.nombreConductor ?? "";
      objEnviar.usuario = formData.usuario;
      objEnviar.password = formData.password;
      objEnviar.peso = formData?.peso ?? 0;
      objEnviar.volumen = formData?.volumen ?? 0;
      objEnviar.nota = formData?.nota ?? "";
      objEnviar.licencia = formData?.licencia ?? "";
      objEnviar.telefono = formData?.telefono ?? "";
      objEnviar.idTipoChofer = tipoChoferSelected !== null ? tipoChoferSelected.value : null;
      objEnviar.idEjesVehiculo = ejesVehiculoSelected !== null ? ejesVehiculoSelected.value : null;
      objEnviar.idEstadoVehiculo = estadoVehiculoSelected !== null ? estadoVehiculoSelected.value : null;
      showProcessing();
      setSendRequest(true);
      const responseCount = await countUsuarioMovil(objEnviar);
      if (responseCount.error === false) {
        // console.log('responseCount');
        // console.log(responseCount);
        const total = responseCount.body;
        if (total >= 1) {
          showToast(t("alert_usuario_movil_ya_existe"), "error");
          hideProcessing();
          return;
        }
        if (formData.id === 0) {
          // console.log('crear correo');
          const response = await crearUsuarioMovil(objEnviar);
          hideProcessing();
          // console.log('creado');
          // console.log(creado);
          if (response.error === false) {
            showToast(t("alert_se_creo_correctamente"));
            handleCancelClick();
          }
          if (response.error === true) {
            showToast(t("alert_no_se_pudo_crear"));
          }
        }
        if (formData.id !== 0) {
          // console.log('actualizar correo');
          const response = await actualizarUsuarioMovil(objEnviar);
          hideProcessing();
          // console.log('modificado');
          // console.log(modificado);
          if (response.error === false) {
            showToast(t("alert_se_modifico_correctamente"));
            handleCancelClick();
          }
          if (response.error === true) {
            showToast(t("alert_no_se_pudo_modificar"));
          }
        }
      }
      if (responseCount.error === true) {
        showToast(responseCount.message, "error");
        hideProcessing();
      }
    } catch (error) {
      console.log('handleSaveClick err');
      console.log(error);
    } finally {
      // console.log('execute finally');
      setSendRequest(false);
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="tipo-usuario-movil">
                  {t("label_tipo_usuario_movil")}<span className="text-red-500">*</span>
                </label>
                <Select options={listaTipoUsuarioMovil}
                  isSearchable={true}
                  isClearable={true}
                  value={tipoUsuarioMovilSelected}
                  onChange={(event) => setTipoUsuarioMovilSelected(event)}
                  placeholder={t("placeholder_seleccione_tipo_usuario_movil")}
                />
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="pais">
                  {t("label_pais")}
                </label>
                <Select options={listaPais}
                  isSearchable={true}
                  isClearable={true}
                  value={paisSelected}
                  onChange={(event) => setPaisSelected(event)}
                  placeholder={t("placeholder_seleccione_pais")}
                />
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="ciudad">
                  {t("label_ciudad")}
                </label>
                <Select options={listaCiudad}
                  isSearchable={true}
                  isClearable={true}
                  value={ciudadSelected}
                  onChange={(event) => setCiudadSelected(event)}
                  placeholder={t("placeholder_seleccione_ciudad")}
                />
              </div>
            </div>
            {tipoUsuarioMovilSelected?.esChofer === 1 &&
              <div className="grid grid-cols-12 gap-4 mt-4">
                <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                  <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="vehiculo">
                    {t("label_vehiculo")}<span className="text-red-500">*</span>
                  </label>
                  <Select options={listaUnidad}
                    isSearchable={true}
                    isClearable={true}
                    value={unidadSelected}
                    onChange={(event) => setUnidadSelected(event)}
                    placeholder={t("placeholder_seleccione_unidad")}
                  />
                </div>
                <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                  <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="ejesVehiculo">
                    {t("label_ejes_vehiculo")}
                  </label>
                  <Select options={listaEjesVehiculo}
                    isSearchable={true}
                    isClearable={true}
                    value={ejesVehiculoSelected}
                    onChange={(event) => setEjesVehiculoSelected(event)}
                    placeholder={t("placeholder_seleccione_ejes_vehiculo")}
                  />
                </div>
                <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                  <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="ejesVehiculo">
                    {t("label_estado_vehiculo")}
                  </label>
                  <Select options={listaEstadoVehiculo}
                    isSearchable={true}
                    isClearable={true}
                    value={estadoVehiculoSelected}
                    onChange={(event) => setEstadoVehiculoSelected(event)}
                    placeholder={t("placeholder_seleccione_estado_vehiculo")}
                  />
                </div>
              </div>
            }
            {tipoUsuarioMovilSelected?.esChofer === 1 &&
              <div className="grid grid-cols-12 gap-4 mt-4">
                <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                  <label
                    htmlFor="peso"
                    className="block text-md font-medium text-gray-700"
                  >
                    {t("label_peso")}<span className="text-red-500">*</span>
                  </label>
                  <input
                    id="peso"
                    name="peso"
                    type="text"
                    value={formData.peso}
                    onChange={handleInputChange}

                    className={ESTILO_INPUT_GENERICO}
                    required
                    maxLength={charLimits.peso}
                    placeholder={t("placeholder_ingresa_peso")}
                  />
                  <p className="text-sm text-gray-500 flex justify-end">{formData.peso.length}/{charLimits.peso}</p>
                </div>
                <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                  <label
                    htmlFor="volumen"
                    className="block text-md font-medium text-gray-700"
                  >
                    {t("label_volumen")}<span className="text-red-500">*</span>
                  </label>
                  <input
                    id="volumen"
                    name="volumen"
                    type="text"
                    value={formData.volumen}
                    onChange={handleInputChange}

                    className={ESTILO_INPUT_GENERICO}
                    required
                    maxLength={charLimits.volumen}
                    placeholder={t("placeholder_ingresa_volumen")}
                  />
                  <p className="text-sm text-gray-500 flex justify-end">{formData.volumen.length}/{charLimits.volumen}</p>
                </div>
              </div>
            }
            {tipoUsuarioMovilSelected?.esChofer === 1 &&
              <>
                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-12 md:col-span-6 lg:col-span-8 xl:col-span-8">
                    <label
                      htmlFor="nombreConductor"
                      className="block text-md font-medium text-gray-700"
                    >
                      {t("label_nombre")}<span className="text-red-500">*</span>
                    </label>
                    <input
                      id="nombreConductor"
                      name="nombreConductor"
                      type="text"
                      value={formData.nombreConductor}
                      onChange={handleInputChange}

                      className={ESTILO_INPUT_GENERICO}
                      required
                      maxLength={charLimits.nombreConductor}
                      placeholder={t("placeholder_ingresa_nombre")}
                    />
                    <p className="text-sm text-gray-500 flex justify-end">{formData.nombreConductor.length}/{charLimits.nombreConductor}</p>
                  </div>
                </div>
                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                    <label
                      htmlFor="licencia"
                      className="block text-md font-medium text-gray-700"
                    >
                      {t("label_licencia")}
                    </label>
                    <input
                      id="licencia"
                      name="licencia"
                      type="text"
                      value={formData.licencia}
                      onChange={handleInputChange}

                      className={ESTILO_INPUT_GENERICO}
                      required
                      maxLength={charLimits.licencia}
                      placeholder={t("placeholder_ingresa_licencia")}
                    />
                    <p className="text-sm text-gray-500 flex justify-end">{formData?.licencia?.length ?? 0}/{charLimits.licencia}</p>
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                    <label
                      htmlFor="telefono"
                      className="block text-md font-medium text-gray-700"
                    >
                      {t("label_telefono")}
                    </label>
                    <input
                      id="telefono"
                      name="telefono"
                      type="text"
                      value={formData.telefono}
                      onChange={handleInputChange}

                      className={ESTILO_INPUT_GENERICO}
                      required
                      maxLength={charLimits.telefono}
                      placeholder={t("placeholder_ingresa_telefono")}
                    />
                    <p className="text-sm text-gray-500 flex justify-end">{formData?.telefono?.length ?? 0}/{charLimits.telefono}</p>
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="tipoChofer">
                      {t("label_tipo_chofer")}
                    </label>
                    <Select options={listaTipoChofer}
                      isSearchable={true}
                      isClearable={true}
                      value={tipoChoferSelected}
                      onChange={(event) => setTipoChoferSelected(event)}
                      placeholder={t("placeholder_seleccione_tipo_chofer")}
                    />
                  </div>
                </div>
              </>
            }
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="usuario"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_usuario")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="usuario"
                  name="usuario"
                  type="text"
                  value={formData.usuario}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.usuario}
                  placeholder={t("placeholder_ingresa_usuario")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.usuario.length}/{charLimits.usuario}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="password"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_password")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="password"
                  name="password"
                  type="text"
                  value={formData.password}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.password}
                  placeholder={t("placeholder_ingresa_password")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.password.length}/{charLimits.password}</p>
              </div>
            </div>
            {/* <br /> */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="nota"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_nota")}
                </label>
                <textarea
                  id="nota"
                  name="nota"
                  type="text"
                  value={formData.nota}
                  onChange={handleInputChange}

                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.nota}
                  placeholder={t("placeholder_ingresa_nota")}
                  rows={5}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.nota?.length}/{charLimits.nota}</p>
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    Cancelar
                  </button>
                  {sendRequest === false && (
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      onClick={handleSaveClick}
                    >
                      Aceptar
                    </button>
                  )}
                  {sendRequest === true && (
                    <BtnRequestComponent label={t("label_aceptar")} />
                  )}
                </div>
              </div>
            </div>
          </div >
        </div >
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
